import { getLeaguesForFixtures, } from '../../jsCore/application/pageDataObject';
export function getLeagueId2Name(){
  return getLeaguesForFixtures().reduce((accumulator, curr) => {
    return { ...accumulator, [curr.id]: curr.name };
  }, {});
}
export function getLeagueName2Id(){
  return getLeaguesForFixtures().reduce((accumulator, curr) => {
    return { ...accumulator, [curr.name]: curr.id };
  }, {});
}
export function getLeagueNames(){
  return getLeaguesForFixtures().map(leagueData => leagueData.name);
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/schedule/leagueTransformUtil.js